import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { LoginSuccess } from '@app/core/user/store/actions';

/**
 * When user logs in / When the log in is validated.
 */
const events = getEvents((action: LoginSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'account',
      accountAction: 'login',
      accountType: action.payload.accountType ? action.payload.accountType : 'regular'
    }
  }
]);

export default events;
